import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_ORDERS',
    icon: 'MoreVerticalIcon',
    route: 'orders',
    action: constants.action.permissionOrdersList,
    resource: constants.resource.user,
  },
]
